import { LoggedUser, Team } from 'entities';

import { RoutePermissions } from './build';

interface PermissionProps {
  customPermissionCheck?: (user: LoggedUser) => boolean;
  permissions?: RoutePermissions;
}

export function shouldBlockRoute(
  { customPermissionCheck, permissions }: PermissionProps,
  user: LoggedUser,
): boolean {
  if (!permissions && !customPermissionCheck) return false;

  if (customPermissionCheck) return !customPermissionCheck(user);

  const { type, isSysAdmin, team: teamProps = {} } = permissions ?? {};
  const { type: userType, team, isSysAdmin: userIsSysAdmin } = user;

  const typeBlock = type ? userType !== type : false;
  const adminBlock = typeof isSysAdmin === 'boolean' && isSysAdmin ? !userIsSysAdmin : false;

  if (typeBlock || adminBlock) return true;

  const teamBlock = Object.entries(teamProps).some(
    ([prop, value]) => team[prop as keyof Team] !== value,
  );

  return teamBlock;
}
